export default "__VITE_ASSET__DSNCq$GZ__"